import React from "react";
import { SvgProps } from ".";

export const AccountSvg: React.FC<SvgProps> = ({ fill }) => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-labelledby="Account"
    >
      <title id="Account">Account</title>
      <g
        id="Account"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="0.5"
      >
        <g
          id="Simplified---Expanded-Nav---LG"
          transform="translate(-1125.000000, -232.000000)"
        >
          <g
            id="Account-dropdown"
            transform="translate(1110.000000, 78.000000)"
          >
            <g id="Group" transform="translate(15.000000, 154.000000)">
              <rect id="Rectangle" x="0" y="0" width="30" height="30" />
              <path
                d="M4.6875,20.625 L4.6875,8.4375 C4.6875,7.40196609 5.52696609,6.5625 6.5625,6.5625 L23.4375,6.5625 C24.4730339,6.5625 25.3125,7.40196609 25.3125,8.4375 L25.3125,20.625"
                id="Path"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.8125,20.625 L27.1875,20.625 L27.1875,22.5 C27.1875,23.5355339 26.3480339,24.375 25.3125,24.375 L4.6875,24.375 C3.65196609,24.375 2.8125,23.5355339 2.8125,22.5 L2.8125,20.625 Z"
                id="Path"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="14.6772764"
                y1="15.440893"
                x2="21.6772764"
                y2="15.440893"
                id="Path-2"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
              />
              <line
                x1="14.6772764"
                y1="11.440893"
                x2="21.6772764"
                y2="11.440893"
                id="Path-2"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
              />
              <line
                x1="8.75306692"
                y1="15.440893"
                x2="11.6772764"
                y2="15.440893"
                id="Path-2"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
              />
              <line
                x1="8.75306692"
                y1="11.440893"
                x2="11.6772764"
                y2="11.440893"
                id="Path-2"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default {};
